import axios from "axios";

let unauthorizedHandled = false;

const UNAUTHORIZED_STATUS_CODE = 401;

type ErrorShape = {
	statusCode?: number;
	status?: number;
	message?: string;
	response?: { status?: number };
	error?: { statusCode?: number; status?: number; message?: string };
};

const getStatusCode = (error: unknown): number | undefined => {
	if (!error || typeof error !== "object") {
		return undefined;
	}

	const value = error as ErrorShape;
	return value.statusCode ?? value.status ?? value.response?.status ?? value.error?.statusCode ?? value.error?.status;
};

export const isUnauthorizedError = (error: unknown): boolean => {
	if (!error) {
		return false;
	}

	if (axios.isAxiosError(error)) {
		return error.response?.status === UNAUTHORIZED_STATUS_CODE;
	}

	if (getStatusCode(error) === UNAUTHORIZED_STATUS_CODE) {
		return true;
	}

	return false;
};

export const handleUnauthorizedFailure = (error: unknown): boolean => {
	if (!isUnauthorizedError(error) || unauthorizedHandled) {
		return false;
	}

	unauthorizedHandled = true;
	window.location.reload();
	return true;
};

export const resetUnauthorizedFailureGuard = () => {
	unauthorizedHandled = false;
};
